// src/graphql/mutations/teamMutations.js

export const adminInviteTeamMember = `mutation AdminInviteTeamMember($input: InviteUserInput!) {
    inviteTeamMember(input: $input) {
        success
        error
        invitation {
            id
            inviteeEmail
            type
            status
            role
            expiresAt
            createdAt
        }
    }
}`;

export const adminCancelInvitation = `mutation AdminCancelInvitation($invitationId: String!) {
    cancelInvitation(invitationId: $invitationId) {
        success
        error
    }
}`;

export const adminRespondToJoinRequest = `mutation AdminRespondToJoinRequest($input: RespondToJoinRequestInput!) {
    respondToJoinRequest(input: $input) {
        success
        error
    }
}`;

export const adminRemoveTeamMember = `mutation AdminRemoveTeamMember($userId: String!) {
    removeTeamMember(userId: $userId) {
        success
        error
    }
}`;

export const adminTransferRepresentative = `mutation AdminTransferRepresentative($newRepUserId: String!) {
    transferRepresentative(newRepUserId: $newRepUserId) {
        success
        error
    }
}`;

export const adminSetCompanyUserLimit = `mutation AdminSetCompanyUserLimit($companyId: String!, $maxUsers: Int!) {
    adminSetCompanyUserLimit(companyId: $companyId, maxUsers: $maxUsers) {
        success
        error
    }
}`;
